(ns machtfit.widgets.countdown
  (:require [cljs-time.coerce :as time.coerce]
            [cljs-time.core :as time]
            [clojure.string :as str]
            [goog.string :as gstring]
            [machtfit.translation :refer [t trnp]]
            [machtfit.widgets.badge :as badge]
            [machtfit.widgets.icon :as icon]
            [reagent.core :as r]))

(defn countdown-with-units [[h m s]]
  {:hours h
   :minutes m
   :seconds s
   :units {:hours (trnp {:de "Stunde"
                         :en "hour"}
                        {:de "Stunden"
                         :en "hours"}
                        h)
           :minutes (trnp {:de "Minute"
                           :en "minute"}
                          {:de "Minuten"
                           :en "minutes"}
                          m)
           :seconds (trnp {:de "Sekunde"
                           :en "second"}
                          {:de "Sekunden"
                           :en "seconds"}
                          s)}})

(defn get-countdown-values [{:keys [from until expand-unit?]}]
  (let [seconds-total (- until from)
        seconds-total (int seconds-total)
        seconds (mod seconds-total 60)
        minutes-total (quot seconds-total 60)
        minutes (rem minutes-total 60)
        hours (quot minutes-total 60)]
    (if-not expand-unit?
      (if (neg? seconds-total)
        "00:00:00"
        (str/join ":" (map #(gstring/format "%02d" %) [hours minutes seconds])))
      (if (neg? seconds-total)
        (countdown-with-units [0 0 0])
        (countdown-with-units [hours minutes seconds])))))

(defn countdown-badge [countdown-label until]
  (let [tick (r/atom 0)]
    (fn []
      (js/setTimeout #(swap! tick inc) 1000)
      @tick
      (let [from (time.coerce/to-epoch (time/now))]
        [badge/pill-outline {:text [:span.border-raspberrypink-500 [t countdown-label]
                                    [:strong (get-countdown-values {:from from
                                                                    :until until})]]
                             :color :raspberrypink}]))))

(defn countdown-item [item unit]
  [:div.flex.flex-col.text-center.text-base.items-center
   [:strong.flex.items-center.justify-center.bg-raspberrypink-500.text-white.rounded-full.text-center.leading-none.px-1.py-3.mx-1
    {:class "w-11 min-w-7 h-[30px]"}
    item]
   [:span.text-xs
    {:class "leading-4.5"}
    unit]])

(defn countdown-box [countdown-label until]
  (let [tick (r/atom 0)]
    (fn []
      (js/setInterval #(swap! tick inc) 1000)
      @tick
      (let [from (time.coerce/to-epoch (time/now))
            {:keys [hours minutes seconds units]} (get-countdown-values {:from from
                                                                         :until until
                                                                         :expand-unit? true})]
        [:div.flex.bg-raspberrypink-25.text-raspberrypink-500.px-4.py-2.rounded-lg.md:rounded-xl.gap-2.items-center
         [:div.flex.px-2.py-4.items-center
          [icon/outline "clock-fast-forward" {:width "w-8"
                                              :height "h-8"
                                              :stroke "stroke-raspberrypink-500"}]]
         [:div.flex.items-center.gap-4.w-full.justify-start.py-2
          [:strong [t countdown-label]]
          [:div.flex.items-center.gap-1
           [countdown-item hours (:hours units)]
           [countdown-item minutes (:minutes units)]
           [countdown-item seconds (:seconds units)]]]]))))

(defn main [end-time {:keys [countdown-label display-type]}]
  (let [until (time.coerce/to-epoch end-time)]
    (case display-type
      :badge [countdown-badge countdown-label until]
      :box [countdown-box countdown-label until])))
